import { render, staticRenderFns } from "./CustomerImportXLSX.vue?vue&type=template&id=afbcc290&scoped=true&"
import script from "./CustomerImportXLSX.vue?vue&type=script&lang=js&"
export * from "./CustomerImportXLSX.vue?vue&type=script&lang=js&"
import style0 from "./CustomerImportXLSX.vue?vue&type=style&index=0&id=afbcc290&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbcc290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VDataTable,VIcon,VRow})
